import { Model as o } from "../../../model.js";
class r extends o {
  constructor(t) {
    super(), this.configuration = t.configuration, this.checkout = t.checkout, this.cart = t.cart;
  }
}
export {
  r as CheckoutSettingsModel
};
//# sourceMappingURL=settings.model.js.map
